const MAX_DISPLAYED_COUNT = 99;

// Three characters at most so the count fits in the round badge
export const getUnreadCountLabel = (count: number) =>
    count > MAX_DISPLAYED_COUNT ? `${MAX_DISPLAYED_COUNT}+` : String(count);
